export const UNITS_OF_MEASURE = {
  imperial: 'imperial',
  canada: 'canada',
  si: 'si'
};
